import { useEffect } from "react";

// Wikkelt platte tekstregels in <p>, maar laat regels die al met een
// blok-element beginnen (header, lijst, paragraaf) ongewijzigd staan.
function toStoryHtml(story) {
  return story
    .split(/\n+/)
    .map(line => line.trim())
    .filter(Boolean)
    .map(line => (/^<(h2|h3|ul|ol|p)[ >]/i.test(line) ? line : `<p>${line}</p>`))
    .join("");
}

export default function StoryModal({ name, story, tags, onClose }) {
  useEffect(() => {
    const onKey = e => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <div className="terms-overlay" onClick={onClose}>
      <div className="story-modal" onClick={e => e.stopPropagation()}>
        <div className="story-modal-header">
          <h2>Het verhaal van {name}</h2>
          <button type="button" className="terms-close" onClick={onClose} aria-label="Sluiten">×</button>
        </div>
        <div className="story-modal-body">
          {tags && tags.length > 0 && (
            <div className="story-modal-tags">
              {tags.map(tag => <span key={tag} className="story-modal-tag">{tag}</span>)}
            </div>
          )}
          <div dangerouslySetInnerHTML={{ __html: toStoryHtml(story) }} />
        </div>
      </div>
    </div>
  );
}
